import { associations, Relation } from "@nozbe/watermelondb";
import {
  date,
  field,
  json,
  lazy,
  relation,
  text,
  writer,
} from "@nozbe/watermelondb/decorators";
import { noopSanitizeJSON } from "../utils";
import { BaseModel } from "./Base";
import ReceiptTemplate from "./ReceiptTemplate";
import { Q } from "@nozbe/watermelondb";
import PaymentMethod from "./PaymentMethod";

export default class Terminal extends BaseModel {
  static table = "terminals";

  static associations = associations([
    "receipt_template",
    { type: "belongs_to", key: "default_receipt_template_id" },
  ]);

  @relation("receipt_template", "default_receipt_template_id")
  defaultReceiptTemplate: Relation<ReceiptTemplate>;

  @text("name") name: string;
  @field("invoice_sequence") invoiceSequence: number;
  @text("sale_sufix") saleSufix?: string | null;
  @text("sale_prefix") salePrefix?: string | null;
  @field("enabled") enabled: boolean;
  @text("print_receipt_on_checkout") printReceiptOnCheckout: boolean;

  @json("payment_method_ids", noopSanitizeJSON) paymentMethodIds: string[];

  // NOTE: these need to be changed on the server - they will be overwritten
  // by the server if there is a conflict during sync
  @date("terminal_open_time") terminalOpenTime: Date | null;
  @date("terminal_close_time") terminalCloseTime: Date | null;
  @text("open_terminal_closure_id") openTerminalClosureId: string | null;

  @writer async updateClosureDetails(input: {
    terminalOpenTime: Date;
    terminalCloseTime: Date;
    openTerminalClosureId: string;
  }) {
    await this.update((terminal) => {
      terminal.terminalOpenTime = input.terminalOpenTime;
      terminal.terminalCloseTime = input.terminalCloseTime;
      terminal.openTerminalClosureId = input.openTerminalClosureId;
    });
  }

  @writer async enableTerminal() {
    await this.update((terminal) => {
      terminal.enabled = true;
    });
  }

  @lazy paymentMethods = this.collections
    .get<PaymentMethod>("payment_methods")
    //@ts-ignore
    .query(Q.where("id", Q.oneOf(this.paymentMethodIds)));

  @writer async clearClosureDetails() {
    await this.update((terminal) => {
      terminal.openTerminalClosureId = null;
    });
  }
}
